<template>
  <p class="banner-wrapper">{{ formItem.title }}</p>
</template>
<script>
export default {
  props: ["formItem"],
  mounted() {},
};
</script>
<style lang="scss" scoped>
.banner-wrapper {
  padding: 0 0.4rem 0.4rem 0.4rem;
  font-size: 0.32rem;
  font-style: oblique;
  font-weight: 500;
  color: #333333;
}
</style>


